/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { borderRadius as getBorderRadius } from '@atlaskit/theme/constants';
import { h600 } from '@atlaskit/theme/typography';
const borderRadius = getBorderRadius();

// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
const lightH600Styles = css(h600({
  theme: {
    mode: 'light'
  }
}));
// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
const darkH600Styles = css(h600({
  theme: {
    mode: 'dark'
  }
}));
const modalBodyStyles = css({
  padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-250, 20px)"}`,
  textAlign: 'center'
});

// eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
const modalHeadingStyles = css({
  marginBottom: "var(--ds-space-100, 8px)",
  color: 'inherit'
});
const modalImageStyles = css({
  width: '100%',
  height: 'auto',
  borderTopLeftRadius: `${borderRadius}px`,
  borderTopRightRadius: `${borderRadius}px`,
  '@media (min-width: 320px) and (max-width: 480px)': {
    borderRadius: 0
  }
});
const modalActionContainerStyles = css({
  display: 'flex',
  padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
  justifyContent: 'center',
  flexDirection: 'row',
  flexFlow: 'wrap'
});
const modalActionContainerReversedStyles = css({
  flexDirection: 'row-reverse'
});
const modalActionItemStyles = css({
  margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});

/**
 * __Modal body__
 *
 * @internal
 */
export const ModalBody = ({
  children
}) => jsx("div", {
  css: modalBodyStyles
}, children);

/**
 * __Modal heading__
 *
 * @internal
 */
export const ModalHeading = ({
  children
}) => {
  const {
    mode
  } = useGlobalTheme();
  return jsx("h4", {
    css: [mode === 'light' ? lightH600Styles : darkH600Styles, modalHeadingStyles]
  }, children);
};

/**
 * __Modal image__
 *
 * @internal
 */
export const ModalImage = ({
  alt,
  src
}) => jsx("img", {
  css: modalImageStyles,
  alt: alt,
  src: src
});

/**
 * __Modal action container__
 *
 * @internal
 */
export const ModalActionContainer = ({
  children,
  shouldReverseButtonOrder
}) => jsx("div", {
  css: [modalActionContainerStyles, shouldReverseButtonOrder && modalActionContainerReversedStyles]
}, children);

/**
 * __Modal action item__
 *
 * @internal
 */
export const ModalActionItem = ({
  children
}) => jsx("div", {
  css: modalActionItemStyles
}, children);